import React, { useEffect, useRef, useState } from "react";
import { IPaginacion } from "../../Interfaces/filter";
import {
  IDataTableIpercEquipo,
  ITableIpercEquipo,
  InitialTableIpercEquipo,
} from "../../Interfaces/IPERC/IEquipo";
import { ISearchBox } from "@fluentui/react";
import EquipoService from "../../services/Iperc/EquipoService";

export const useTableIpercEquipo = () => {
  const [loading, setLoading] = useState(false);
  const [dataTeble, setDataTeble] = useState<IDataTableIpercEquipo[]>([]);
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const [filter, setFilter] = useState<ITableIpercEquipo>(
    InitialTableIpercEquipo
  );
  const controllerRef = useRef<AbortController>(new AbortController());
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilter({ ...filter, skip: filter.skip + 1 });
        break;
      case "prev":
        setFilter({ ...filter, skip: filter.skip - 1 });
        break;
      default:
        break;
    }
  };
  const searchBoxRefTable = useRef<ISearchBox>(null);
  const _onkeyUpSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const postDataTableIpercEquipo = () => {
    controllerRef.current?.abort();
    const newAbortController = new AbortController();
    controllerRef.current = newAbortController;
    EquipoService.postListarTablaEquipo(filter, newAbortController).then(
      (res) => {
        if (res.status === 200) {
          setLoading(false);
          setDataTeble(res.data.items);
          setPaginacion({
            page: res.data.page,
            total: res.data.total,
            pages: res.data.pages,
          });
        }
      }
    );
  };
  const onClickRefresh = () => {
    if (filter.search !== "") {
      setFilter(InitialTableIpercEquipo);
    } else {
      postDataTableIpercEquipo();
    }
  };
  useEffect(() => {
    postDataTableIpercEquipo();
  }, [filter]);
  return {
    loading,
    dataTeble,
    paginacion,
    onChangeSkip,
    searchBoxRefTable,
    _onkeyUpSearch,
    onClickRefresh,
  };
};
